var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIndiaflag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 17,
    viewBox: "0 0 24 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1240_8760)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 17,
    fill: "#FF4E4E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0H24V17H0V0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0H24V5.66667H0V0Z",
    fill: "#F15B25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 11.3335H24V17.0002H0V11.3335Z",
    fill: "#006934"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9999 11.1211C13.3622 11.1211 14.4665 9.94767 14.4665 8.50023C14.4665 7.05278 13.3622 5.87939 11.9999 5.87939C10.6376 5.87939 9.5332 7.05278 9.5332 8.50023C9.5332 9.94767 10.6376 11.1211 11.9999 11.1211Z",
    fill: "#2C2C6F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0002 10.7667C13.1784 10.7667 14.1335 9.75191 14.1335 8.50006C14.1335 7.24822 13.1784 6.2334 12.0002 6.2334C10.822 6.2334 9.86685 7.24822 9.86685 8.50006C9.86685 9.75191 10.822 10.7667 12.0002 10.7667Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9999 8.95354C12.2356 8.95354 12.4266 8.75058 12.4266 8.50021C12.4266 8.24984 12.2356 8.04688 11.9999 8.04688C11.7643 8.04688 11.5732 8.24984 11.5732 8.50021C11.5732 8.75058 11.7643 8.95354 11.9999 8.95354Z",
    fill: "#2C2C6F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0001 6.23291L12.0801 7.5969L12.0001 8.27224L11.9201 7.5969L12.0001 6.23291Z",
    fill: "#2C2C6F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.2663 6.35069C12.3174 6.35784 12.3643 6.31962 12.371 6.26532C12.3778 6.21102 12.3418 6.16121 12.2907 6.15406C12.2396 6.14691 12.1927 6.18513 12.186 6.23943C12.1792 6.29373 12.2152 6.34354 12.2663 6.35069Z",
    fill: "#2C2C6F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9999 10.7666L11.9199 9.40261L11.9999 8.72727L12.0799 9.40261L11.9999 10.7666Z",
    fill: "#2C2C6F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.7337 10.6488C11.6826 10.6417 11.6357 10.6799 11.629 10.7342C11.6222 10.7885 11.6582 10.8383 11.7093 10.8455C11.7604 10.8526 11.8073 10.8144 11.814 10.7601C11.8208 10.7058 11.7848 10.656 11.7337 10.6488Z",
    fill: "#2C2C6F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5477 6.31167L12.3027 7.65065L12.0595 8.27835L12.1396 7.60348L12.5477 6.31167Z",
    fill: "#2C2C6F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.7818 6.49568C12.8301 6.51741 12.8847 6.49461 12.9037 6.44478C12.9228 6.39494 12.8991 6.33693 12.8507 6.31521C12.8024 6.29349 12.7478 6.31628 12.7288 6.36612C12.7098 6.41595 12.7335 6.47396 12.7818 6.49568Z",
    fill: "#2C2C6F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.4523 10.6878L11.6973 9.34886L11.9405 8.72116L11.8604 9.39603L11.4523 10.6878Z",
    fill: "#2C2C6F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.2182 10.5038C11.1699 10.4821 11.1153 10.5049 11.0963 10.5547C11.0772 10.6046 11.1009 10.6626 11.1493 10.6843C11.1976 10.706 11.2522 10.6832 11.2712 10.6334C11.2902 10.5836 11.2665 10.5255 11.2182 10.5038Z",
    fill: "#2C2C6F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.0644 6.538L12.4965 7.76129L12.1088 8.3014L12.3539 7.67357L13.0644 6.538Z",
    fill: "#2C2C6F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.2426 6.7792C13.284 6.8131 13.3426 6.80582 13.3734 6.76293C13.4043 6.72004 13.3957 6.65779 13.3543 6.62389C13.3129 6.58998 13.2543 6.59727 13.2235 6.64016C13.1926 6.68304 13.2012 6.7453 13.2426 6.7792Z",
    fill: "#2C2C6F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.9353 10.4615L11.5032 9.23822L11.891 8.69812L11.6458 9.32594L10.9353 10.4615Z",
    fill: "#2C2C6F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.7572 10.2203C10.7158 10.1864 10.6572 10.1937 10.6263 10.2366C10.5955 10.2795 10.604 10.3417 10.6454 10.3756C10.6869 10.4095 10.7454 10.4022 10.7763 10.3594C10.8072 10.3165 10.7986 10.2542 10.7572 10.2203Z",
    fill: "#2C2C6F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.507 6.8985L12.659 7.92259L12.1525 8.33756L12.5431 7.79942L13.507 6.8985Z",
    fill: "#2C2C6F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.6191 7.17943C13.651 7.2234 13.7096 7.23243 13.75 7.19961C13.7904 7.16679 13.7974 7.10453 13.7655 7.06057C13.7336 7.0166 13.6751 7.00757 13.6346 7.04039C13.5942 7.07321 13.5873 7.13547 13.6191 7.17943Z",
    fill: "#2C2C6F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4926 10.1015L11.3406 9.07741L11.847 8.66244L11.4565 9.20058L10.4926 10.1015Z",
    fill: "#2C2C6F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.3804 9.82057C10.3486 9.7766 10.29 9.76757 10.2496 9.80039C10.2091 9.83321 10.2022 9.89547 10.2341 9.93943C10.2659 9.9834 10.3245 9.99243 10.3649 9.95961C10.4053 9.92679 10.4123 9.86453 10.3804 9.82057Z",
    fill: "#2C2C6F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.8488 7.36448L12.7742 8.1208L12.1841 8.38834L12.6967 7.97777L13.8488 7.36448Z",
    fill: "#2C2C6F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.8838 7.67153C13.903 7.72153 13.9576 7.74459 14.0057 7.72303C14.0539 7.70147 14.0775 7.64346 14.0583 7.59346C14.0391 7.54346 13.9845 7.52041 13.9363 7.54197C13.8882 7.56353 13.8646 7.62153 13.8838 7.67153Z",
    fill: "#2C2C6F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.1515 9.63552L11.2262 8.8792L11.8163 8.61166L11.3037 9.02223L10.1515 9.63552Z",
    fill: "#2C2C6F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.1166 9.32847C10.0974 9.27847 10.0428 9.25541 9.99466 9.27697C9.94647 9.29853 9.92294 9.35654 9.94211 9.40654C9.96127 9.45654 10.0159 9.47959 10.0641 9.45803C10.1122 9.43647 10.1358 9.37847 10.1166 9.32847Z",
    fill: "#2C2C6F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.0617 7.91087L12.8406 8.34677L12.2062 8.44327L12.8008 8.18715L14.0617 7.91087Z",
    fill: "#2C2C6F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.0221 8.2178C14.0284 8.27165 14.0753 8.30913 14.1268 8.30153C14.1784 8.29393 14.2151 8.24411 14.2088 8.19027C14.2025 8.13642 14.1556 8.09894 14.1041 8.10654C14.0525 8.11414 14.0158 8.16396 14.0221 8.2178Z",
    fill: "#2C2C6F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.93872 9.08913L11.1598 8.65323L11.7942 8.55673L11.1997 8.81285L9.93872 9.08913Z",
    fill: "#2C2C6F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.97833 8.7822C9.97205 8.72835 9.92516 8.69087 9.87361 8.69847C9.82207 8.70607 9.78537 8.75589 9.79166 8.80973C9.79794 8.86358 9.84483 8.90106 9.89638 8.89346C9.94792 8.88586 9.98462 8.83604 9.97833 8.7822Z",
    fill: "#2C2C6F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.1318 8.48938L12.8485 8.57798L12.2148 8.5107L12.8508 8.4293L14.1318 8.48938Z",
    fill: "#2C2C6F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.0234 8.78413C14.0161 8.83902 14.051 8.88883 14.1014 8.89539C14.1519 8.90195 14.1988 8.86277 14.2061 8.80788C14.2135 8.75299 14.1786 8.70318 14.1282 8.69662C14.0777 8.69006 14.0308 8.72924 14.0234 8.78413Z",
    fill: "#2C2C6F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.86763 8.51062L11.151 8.42202L11.7847 8.4893L11.1487 8.5707L9.86763 8.51062Z",
    fill: "#2C2C6F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.9761 8.21587C9.98348 8.16098 9.94856 8.11117 9.89811 8.10461C9.84766 8.09805 9.80078 8.13723 9.79339 8.19212C9.78601 8.24701 9.82093 8.29682 9.87138 8.30338C9.92183 8.30994 9.96872 8.27076 9.9761 8.21587Z",
    fill: "#2C2C6F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.0603 9.08639L12.7996 8.81636L12.2065 8.55933L12.8412 8.65139L14.0603 9.08639Z",
    fill: "#2C2C6F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.8845 9.32954C13.8648 9.3802 13.8873 9.43821 13.9349 9.45911C13.9825 9.48 14.0371 9.45587 14.0568 9.40521C14.0766 9.35455 14.054 9.29654 14.0065 9.27564C13.9589 9.25475 13.9043 9.27888 13.8845 9.32954Z",
    fill: "#2C2C6F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.93927 7.9141L11.2 8.18413L11.7931 8.44116L11.1584 8.3491L9.93927 7.9141Z",
    fill: "#2C2C6F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.1151 7.67095C10.1349 7.62029 10.1123 7.56228 10.0647 7.54138C10.0171 7.52048 9.96254 7.54462 9.94277 7.59528C9.92301 7.64594 9.94556 7.70395 9.99314 7.72485C10.0407 7.74574 10.0953 7.72161 10.1151 7.67095Z",
    fill: "#2C2C6F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.8489 9.63499L12.6967 9.02171L12.1842 8.61113L12.7742 8.87868L13.8489 9.63499Z",
    fill: "#2C2C6F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.6176 9.81817C13.5867 9.86106 13.5953 9.92331 13.6367 9.95721C13.6781 9.99111 13.7367 9.98383 13.7676 9.94094C13.7984 9.89805 13.7899 9.8358 13.7485 9.8019C13.707 9.76799 13.6485 9.77528 13.6176 9.81817Z",
    fill: "#2C2C6F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.1514 7.36452L11.3036 7.9778L11.8161 8.38838L11.226 8.12084L10.1514 7.36452Z",
    fill: "#2C2C6F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.3826 7.18134C10.4135 7.13846 10.4049 7.0762 10.3635 7.0423C10.3221 7.0084 10.2635 7.01568 10.2326 7.05857C10.2018 7.10146 10.2103 7.16371 10.2517 7.19762C10.2932 7.23152 10.3518 7.22423 10.3826 7.18134Z",
    fill: "#2C2C6F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5099 10.1044L12.5451 9.19624L12.1497 8.65914L12.6552 9.07925L13.5099 10.1044Z",
    fill: "#2C2C6F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.2408 10.2187C13.2004 10.2515 13.1936 10.3138 13.2255 10.3578C13.2574 10.4018 13.316 10.4109 13.3564 10.3782C13.3967 10.3454 13.4036 10.2832 13.3717 10.2391C13.3398 10.1951 13.2812 10.186 13.2408 10.2187Z",
    fill: "#2C2C6F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4901 6.89561L11.4549 7.80376L11.8503 8.34086L11.3448 7.92075L10.4901 6.89561Z",
    fill: "#2C2C6F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.7592 6.78126C10.7996 6.74849 10.8064 6.68624 10.7745 6.64222C10.7426 6.59819 10.684 6.58906 10.6436 6.62183C10.6033 6.65459 10.5964 6.71684 10.6283 6.76087C10.6602 6.8049 10.7188 6.81402 10.7592 6.78126Z",
    fill: "#2C2C6F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.0676 10.4632L12.3561 9.32284L12.106 8.69571L12.4927 9.23921L13.0676 10.4632Z",
    fill: "#2C2C6F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.7802 10.5015C12.7328 10.5221 12.7106 10.5801 12.7307 10.631C12.7507 10.6819 12.8053 10.7065 12.8526 10.6858C12.8999 10.6652 12.9221 10.6072 12.9021 10.5563C12.8821 10.5053 12.8275 10.4808 12.7802 10.5015Z",
    fill: "#2C2C6F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.9321 6.53583L11.6436 7.67619L11.8937 8.30332L11.507 7.75981L10.9321 6.53583Z",
    fill: "#2C2C6F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.2196 6.49756C11.2669 6.47691 11.2891 6.4189 11.2691 6.36799C11.2491 6.31708 11.1945 6.29255 11.1471 6.3132C11.0998 6.33385 11.0776 6.39186 11.0976 6.44277C11.1176 6.49368 11.1722 6.51821 11.2196 6.49756Z",
    fill: "#2C2C6F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.553 10.6896L12.1432 9.39312L12.0543 8.71893L12.2958 9.34992L12.553 10.6896Z",
    fill: "#2C2C6F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.2658 10.6481C12.2149 10.655 12.1792 10.7048 12.1861 10.7593C12.1931 10.8139 12.24 10.8525 12.2909 10.8455C12.3418 10.8386 12.3774 10.7888 12.3705 10.7343C12.3636 10.6798 12.3167 10.6412 12.2658 10.6481Z",
    fill: "#2C2C6F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.4466 6.30994L11.8564 7.60639L11.9453 8.28058L11.7038 7.64959L11.4466 6.30994Z",
    fill: "#2C2C6F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.7338 6.35143C11.7847 6.34451 11.8203 6.29469 11.8134 6.24017C11.8065 6.18564 11.7596 6.14705 11.7087 6.15397C11.6578 6.16089 11.6221 6.21071 11.629 6.26523C11.636 6.31976 11.6828 6.35835 11.7338 6.35143Z",
    fill: "#2C2C6F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1240_8760"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 17,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIndiaflag);
export default __webpack_public_path__ + "static/media/India flag.e5e5751099e8085186ea274f4f60b9bc.svg";
export { ForwardRef as ReactComponent };